import { state$ } from "@internal/auth";
import {
  AppErrorBoundary,
  initSentry,
  installGlobalErrorHandlers,
  wireSentryUserToAuth,
} from "@internal/error-handling";
import { createRoot } from "react-dom/client";
import "@/styles/tokens.css";
import "@/styles/global.css";
import { getDb, getDbForUser } from "@/lib/db";
import {
  awaitInitialReplication,
  clearReplicationErrors,
  getReplicationErrors,
  startReplicationOnAuth,
} from "@/lib/replication";
import { registerServiceWorker } from "@/lib/sw";
import { App } from "./App";

initSentry({
  dsn: "https://f2df7a55a93efc2ecd9ff6f55cc89370@o4511315141984256.ingest.de.sentry.io/4511315143622736",
  app: "week-allowance",
  release: `week-allowance@${process.env.GIT_SHA ?? "dev"}`,
  force:
    typeof window !== "undefined" &&
    (window as { __E2E_FORCE_SENTRY__?: boolean }).__E2E_FORCE_SENTRY__ ===
      true,
});
installGlobalErrorHandlers();
wireSentryUserToAuth(state$);

if (process.env.NODE_ENV !== "production") {
  (
    window as unknown as {
      __E2E__: {
        getDb: typeof getDb;
        getDbForUser: typeof getDbForUser;
        awaitInitialReplication: typeof awaitInitialReplication;
        getReplicationErrors: typeof getReplicationErrors;
        clearReplicationErrors: typeof clearReplicationErrors;
      };
    }
  ).__E2E__ = {
    getDb,
    getDbForUser,
    awaitInitialReplication,
    getReplicationErrors,
    clearReplicationErrors,
  };
}

startReplicationOnAuth();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);
